import { freightFormMessages } from '../../../freight-browser/components/freight-form/freight-form-messages';

import type { ServicesGridField } from './ServicesGrid';
import type { LtlDeliveryServices } from '../../../../types/customer';

/**
 * The ten delivery-service checkboxes shared between the Booking Wizard's Ship
 * To step and the Customer record's "LTL Defaults" settings section.
 *
 * Defined here (not inside ShipToStep) so both surfaces reuse the identical
 * array — label drift between wizard and settings is structurally impossible.
 */
export const DELIVERY_SERVICE_FIELDS: ServicesGridField<LtlDeliveryServices>[] = [
  { key: 'isInsideDelivery', label: freightFormMessages.accessorialInsideDelivery },
  { key: 'isConstructionSiteDelivery', label: freightFormMessages.accessorialConstructionSiteDelivery },
  { key: 'isLiftgateDelivery', label: freightFormMessages.accessorialLiftgateDelivery },
  { key: 'isNotifyBeforeDelivery', label: freightFormMessages.accessorialNotifyBeforeDelivery },
  { key: 'isResidentialDelivery', label: freightFormMessages.accessorialResidentialDelivery },
  { key: 'isHoldAtTerminal', label: freightFormMessages.accessorialHoldShipmentAtTerminal },
  { key: 'isGroceryConsolidationDelivery', label: freightFormMessages.accessorialGroceryConsolidationDelivery },
  { key: 'isAppointmentDelivery', label: freightFormMessages.accessorialAppointmentDelivery },
  { key: 'isLimitedAccess', label: freightFormMessages.accessorialLimitedAccess },
  { key: 'isTradeshowDelivery', label: freightFormMessages.accessorialTradeshowDelivery },
];
